import { markRentalTermsAcceptedApi } from '../utils/api';
import { RENTAL_USER_TERMS } from '../constants/statusConstants';
import { getGlobalLogger } from '@zg-rentals/logger-base';
import { logError } from '@zg-rentals/log-error';
const logger = getGlobalLogger(__filename);

const markRentalTermsAccepted = () => (dispatch) => {
  const rentalTermsPayload = {
    type: RENTAL_USER_TERMS,
    version: 0,
  };

  dispatch(markRentalTermsAcceptedApi({ termsAndConditions: [rentalTermsPayload] })).then(
    (response) => {
      if (!(response && response.data && response.data.acceptanceDate)) {
        logger.info('markRentalTermsAccepted error: ', response);
      }
    },
    (error) => {
      logError({ context: 'User saving user terms', error });
    },
  );
};

export { markRentalTermsAccepted };
